<template>
	<div>
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col lg="6" cols="7">
					<p class="text-muted">Customer List</p>
					<h2 class="text-xl d-inline-block mb-0">Pending Acceptance</h2>
				</b-col>
				<b-col cols="6" class="text-right">
					<el-button type="primary" @click="$refs.create_customer_modal.viewCreateCustomer()">Create New</el-button>
				</b-col>
			</b-row>
		</base-header>

		<b-container fluid class="mt--6">
			<PendingAcceptanceTable />
		</b-container>
		<create-customer-modal ref="create_customer_modal" />
	</div>
</template>
<script>
import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn, Button } from 'element-ui';
import PendingAcceptanceTable from '@/views/PendingAcceptance/PendingAcceptanceTable';
import CreateCustomerModal from '@/views/AllCustomers/Modals/CreateCustomerModal';

export default {
	components: {
		PendingAcceptanceTable,
		CreateCustomerModal,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Button.name]: Button,
	},
	data() {
		return {
			isTableLoading: true,
		}
	}
}
</script>